import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class HealthCareUnitService {
    careUnitId: number | undefined;
}
